import api from "../../utils/apiCliente";

export const getPedidoDocs = async (pedidoId) => {
  const res = await api.get(`/api/cliente/pedidos_docs/${pedidoId}`);
  return Array.isArray(res.data) ? res.data : [];
};